module.exports = __webpack_public_path__ + "img/empanadish.49253c85.svg";